import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
// This Module's Components
import { FlyoutSearchComponent } from './flyout-search.component';

@NgModule({ declarations: [FlyoutSearchComponent],
    exports: [FlyoutSearchComponent], imports: [CommonModule,
        DataLayerModule,
        ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class FlyoutSearchModule {}
